// Afisarea publica a unei descrieri: HTML din editorul din #/admin (curatat in BE de
// html_sanitizer si inca o data aici cu DOMPurify, pentru randuri scrise direct in DB),
// sau text simplu (descrierile vechi), impartit pe paragrafe dupa trecerile la rand.
import * as React from 'react';
import DOMPurify from 'dompurify';
import {Box} from '@mui/material';

const ETICHETE = ['p', 'br', 'strong', 'b', 'em', 'i', 'h3', 'ul', 'ol', 'li', 'a'];

export const areEtichete = text => /<[a-z!/]/i.test(text || '');

// Pasul 32: rezumat fara etichete (carduri, homepage) — HTML din editor sau text simplu.
export const textSimplu = text => {
    if (!areEtichete(text)) return (text || '').trim();
    const div = document.createElement('div');
    div.innerHTML = DOMPurify.sanitize(text.replace(/<\/(p|h3|li)>/gi, '</$1> '), {ALLOWED_TAGS: ETICHETE});
    return (div.textContent || '').replace(/\s+/g, ' ').trim();
};

export const curataHtml = html => {
    const curat = DOMPurify.sanitize(html, {ALLOWED_TAGS: ETICHETE, ALLOWED_ATTR: ['href', 'target', 'rel']});
    // Linkurile se deschid in tab nou, fara acces la pagina sursa.
    const div = document.createElement('div');
    div.innerHTML = curat;
    div.querySelectorAll('a').forEach(a => { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener noreferrer'); });
    return div.innerHTML;
};

const stil = {
    lineHeight: 1.7,
    mb: '2rem',
    overflowWrap: 'anywhere',
    '& p': {mt: 0, mb: '1em'},
    '& h3': {fontSize: '1.15rem', fontWeight: 600, mt: '1.5em', mb: '0.5em'},
    '& ul, & ol': {pl: 3, mb: '1em'},
    '& a': {color: 'primary.main'},
};

const DescriereFormatata = ({text}) => {
    if (!text || !text.trim()) return null;
    if (areEtichete(text)) {
        return <Box className="descriere-formatata" sx={stil} dangerouslySetInnerHTML={{__html: curataHtml(text)}} />;
    }
    return (
        <Box className="descriere-formatata" sx={stil}>
            {text.split(/\n+/).filter(r => r.trim()).map((r, i) => <p key={i}>{r}</p>)}
        </Box>
    );
};

export default DescriereFormatata;
